(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.results_common = svs.numbergames.results_common || {};
svs.numbergames.results_common.api_calls = svs.numbergames.results_common.api_calls || {};
svs.numbergames.results_common.helpers = svs.numbergames.results_common.helpers || {};
svs.numbergames.results_common.parsers = svs.numbergames.results_common.parsers || {};
svs.numbergames.results_common.logger = new svs.core.log.Logger('numbergames:results-common');

 })(window);